import { FC, useState } from "react";
import { Icons } from "rujira.ui";

export const useCardCollapse = (initialCollapsed = true) => {
  const [collapsed, setCollapsed] = useState(initialCollapsed);
  return { collapsed, toggle: () => setCollapsed((c) => !c) };
};

export const MobileCardToggle: FC<{
  collapsed: boolean;
  onToggle: () => void;
  moreLabel?: string;
  lessLabel?: string;
}> = ({
  collapsed,
  onToggle,
  moreLabel = "See More",
  lessLabel = "See Less",
}) => (
  <button
    type="button"
    className="mobile-card__toggle"
    aria-expanded={!collapsed}
    onClick={onToggle}>
    <span className="mobile-card__label">
      {collapsed ? moreLabel : lessLabel}
    </span>
    {collapsed ? (
      <Icons.AngleDown className="w-1.5 h-1.5" />
    ) : (
      <Icons.AngleUp className="w-1.5 h-1.5" />
    )}
  </button>
);
